import { getWorkOrderAttachments } from "@/pages/work-orders/repositorie/WorkOrdersRepositorie";
import { useWorkOrderModalsContext } from "@/shared/work-orders-modals/context/work-order-modals.context";
import { get } from "lodash-es";

type Props = {
	setIsWorkOrderAttachmentsLoading: (isLoading: boolean) => void;
	setWorkOrderAttachmentsError: (err: string) => void;
	WorkOrderId: number | null;
};

export const useSearchWorkOrderAttachments = ({
	setIsWorkOrderAttachmentsLoading,
	setWorkOrderAttachmentsError,
	WorkOrderId,
}: Props) => {
	const {
		actions: { setWorkOrderAttachmentsList },
	} = useWorkOrderModalsContext();

	return async () => {
		setWorkOrderAttachmentsList([]);
		setIsWorkOrderAttachmentsLoading(true);
		const res = await getWorkOrderAttachments(WorkOrderId as number);
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			setWorkOrderAttachmentsList(rowsSource);
			setIsWorkOrderAttachmentsLoading(false);
		} else {
			setIsWorkOrderAttachmentsLoading(false);
			setWorkOrderAttachmentsError(res.message);
		}
	};
};
